import { useParams } from "react-router";
import { usePlaylists } from "frontend/src/domain/playlists/selectors";
import { paths } from "frontend/src/pages/paths";
import { useCreatePlaylist } from "frontend/src/domain/playlists";
import { useViewer } from "frontend/src/domain/session";
export var usePageModel = function () {
    var _a, _b;
    var type = useParams().type;
    var user = useViewer().user;
    var _c = usePlaylists({
        type: type,
        take: 100,
        skip: 0,
        isPublished: true,
        clientId: type === "private" ? user === null || user === void 0 ? void 0 : user.clientId : null,
        orderBy: type === "private" ? 'updated_at' : 'order',
        orderByDirection: type === "private" ? 'desc' : 'asc',
    }), data = _c.data, isLoading = _c.isLoading;
    var create = useCreatePlaylist();
    var createNewPlaylist = function () {
        if (user === null || user === void 0 ? void 0 : user.clientId) {
            create.run({
                type: "private",
                title: "Новый плейлист",
                isPublished: true,
                clientId: user.clientId,
                tracks: [],
            });
        }
    };
    var playlists = data === null || data === void 0 ? void 0 : data.items.map(function (_a) {
        var id = _a.id, title = _a.title, duration = _a.duration, trackCount = _a.trackCount, updatedAt = _a.updatedAt, canBeDeleted = _a.canBeDeleted, type = _a.type;
        return ({
            id: id,
            title: title,
            duration: duration.formatted,
            trackCount: trackCount,
            updatedAt: updatedAt.slice(0, 10),
            url: type === "private"
                ? paths.business.owner.playlists.edit(id)
                : paths.business.owner.playlists.view(id),
            permissions: {
                play: trackCount > 0,
                view: type === "public",
                edit: type === "private",
                delete: canBeDeleted,
                copy: true,
            },
        });
    });
    var empty = (_a = (playlists === null || playlists === void 0 ? void 0 : playlists.length) === 0) !== null && _a !== void 0 ? _a : false;
    return {
        isLoading: isLoading,
        type: { private: type === "private" },
        playlists: {
            items: playlists,
            empty: empty,
            create: {
                run: createNewPlaylist,
                pending: create.isLoading,
                isSuccess: create.isSuccess,
                id: (_b = create.data) === null || _b === void 0 ? void 0 : _b.id,
            },
        },
    };
};
